import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import analytics from "../Services/analyticsService";

// Manual pageview/screen tracking on every route change. PostHog's
// autocapture pageview support was confirmed NOT to fire reliably for the
// sibling React Native app's router (zero $screen events in live data
// despite autocapture being on) — capture_pageview is disabled in
// analyticsService.ts's init() for the same reason, so this is the only
// source of pageview events. Verify against live PostHog data once this
// project has real traffic; if autocapture turns out fine here, remove
// this hook rather than leaving both running (double-counts).
export default function useAnalyticsPageviews() {
  const location = useLocation();

  useEffect(() => {
    analytics.screen(location.pathname);
  }, [location.pathname]);
}
